<ax-value-view type="RICH_TEXT" [value]="parsedTextTemplate$ | async"></ax-value-view>
